import { render, staticRenderFns } from "./PecManager.vue?vue&type=template&id=6c8ac965"
import script from "./PecManager.vue?vue&type=script&lang=js"
export * from "./PecManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports